import { render } from "./Inplace.vue?vue&type=template&id=578897e7"
import script from "./Inplace.vue?vue&type=script&lang=js"
export * from "./Inplace.vue?vue&type=script&lang=js"

import "./Inplace.vue?vue&type=style&index=0&id=578897e7&lang=css"
script.render = render

export default script